export { default } from './LazyPrivacyNoticeMx';
